import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Nullable } from "store/types";
import { BaseModal } from "store/types/modals";

import { useModals } from "../../../hooks";

import "./Notice.styles.scss";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none"
};

export const Notice: React.FC<{ data: Nullable<BaseModal> }> = ({ data }) => {
  const { closeNoticeModal } = useModals();
  return (
    <Modal open={!!data} onClose={closeNoticeModal}>
      <Box sx={style}>
        <div className="info-modal">
          <div className="info-modal__head">
            <span>Notice</span>
            <IconButton onClick={closeNoticeModal}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className="info-modal__body">
            <div className="info-modal__body-message">{data?.msg}</div>
            <Button onClick={closeNoticeModal} variant="contained">
              Ok
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
